import React from 'react';

import * as common from '@scss/common.module.scss';

export const VisuallyHidden = ({ children }) => {
  return <span className={common.visuallyHidden}>{children}</span>;
};
